import React from 'react'
import { Element } from 'react-bulma-components'
import { WorkerCounter } from '../../api/worker-counters'
import { formatDuration } from '../../utils/date'

/**
 * Props pour le composant PayrollWorkerDetails
 */
interface PayrollWorkerPeriodDetailsProps {
  /** Compteurs de travailleur */
  workerCounters?: WorkerCounter[]
  /** Fonction appelée quand un compteur de travailleur est cliqué */
  onWorkerCounterClick?: (counter: WorkerCounter) => void
}

/**
 * Composant pour afficher les détails d'un travailleur dans la section paie
 *
 * Affiche les informations contractuelles, les heures travaillées et les compteurs
 * sous forme de liste de description.
 */
const PayrollWorkerPeriodDetails: React.FC<PayrollWorkerPeriodDetailsProps> = ({
  workerCounters,
  onWorkerCounterClick,
}) => {
  return (
    <Element renderAs="strong" data-test="worker-counters-details">
      <Element renderAs="span">Compteurs</Element>
      {workerCounters?.map((counter, index) => (
        <>
          <Element
            renderAs="a"
            ml={2}
            style={{ cursor: 'pointer', textDecoration: 'none' }}
            onClick={() => onWorkerCounterClick?.(counter)}
            data-test={`worker-counter-${counter.template._id}`}
          >
            {counter.template.name}: {formatDuration(counter.currentValue)}
          </Element>
          {index < workerCounters.length - 1 && (
            <Element renderAs="span" ml={2}>
              -
            </Element>
          )}
        </>
      ))}
    </Element>
  )
}

export default PayrollWorkerPeriodDetails
